import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Cacheable } from '../models/cacheable.model';
import { OperationStream } from '../models/operation-stream.model';
import { CapabilitiesService } from '../shared-context/capabilities.service';
import { ObservableHelper } from '../utilities/observable-helper.utility';
import { LocalStorageService } from './local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class CacheFirstRequestService {
    constructor(
        private readonly storageService: LocalStorageService,
        private readonly capabilitiesService: CapabilitiesService) { }

    public makeRequest<T extends Cacheable>(
        requestId: string,
        refreshNetworkIntervalInSeconds: number,
        cacheOnlyRequest: () => Promise<T>,
        networkFirstRequest: () => Promise<T>,
        updateStream?: Observable<T>,
        onInitialNetworkError?: (reason: any) => void
    ): OperationStream<T> {

        if (this.capabilitiesService.capabilities.limitNetworkRequests && refreshNetworkIntervalInSeconds) {
            const cacheKey = this.getKey(requestId);
            const lastNetworkRequestTimeMs = this.storageService.get(cacheKey);
            let makeNetworkRequest = true;
            if (lastNetworkRequestTimeMs && lastNetworkRequestTimeMs + (refreshNetworkIntervalInSeconds * 1000) >= Date.now()) {
                makeNetworkRequest = false;
            }

            const updateNetworkTimestamp = () => {
                this.storageService.set(cacheKey, Date.now());
            };

            if (makeNetworkRequest) {
                const networkPromise = networkFirstRequest().then(resp => {
                    if (resp) {
                        updateNetworkTimestamp();
                    }

                    return resp;
                });
                return ObservableHelper.createResultsWithCacheObservable(cacheOnlyRequest(), networkPromise, updateStream, onInitialNetworkError);
            }

            return ObservableHelper.createResultsCacheFirstObservable(cacheOnlyRequest, networkFirstRequest, updateNetworkTimestamp, updateStream, onInitialNetworkError);
        }

        return ObservableHelper.createResultsWithCacheObservable(cacheOnlyRequest(), networkFirstRequest(), updateStream, onInitialNetworkError);
    }

    private getKey(requestId: string) {
        return `network_ts_${requestId}`;
    }
}
